import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import Button from "./Button";
import {useTranslation} from "react-i18next";
const Modal = (props) => {
  const {t} = useTranslation();
  //close popup on escape button
  useEffect(() => {
    const close = (e) => {
      if(e.keyCode === 27){
        props.onClose()
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  },[])

  if(!props.showPopup){
    return null
  }

  return (
    <div className={"modal"} onClick={props.onClose}>
      <div className={"modal-card " + (props.className|| "")} onClick={e => e.stopPropagation()}>
        <div className={"modal-card-head"}>
          <h1 className={"modal-card-title"}>{props.title}</h1>
        </div>
        {props.body ?  props.body :
          <div>
        <section className={"modal-card-body"}>{props.content}</section>
        <div className={"modal-card-foot"}>
          <Button
            color={props.confirmButtonColor ?? "danger"}
            label={props.label}
            onClick={props.onDelete}
          />
          <Button
            color="primary"
            label={t('Cancel')}
            isOutlined={true}
            onClick={props.onClose}
          />
        </div>
          </div>
        }
      </div>
    </div>
  )
}

Modal.propTypes = {
  title: PropTypes.string,
  showPopup: PropTypes.bool,
  onClose: PropTypes.func,
  content: PropTypes.string,
  onDelete: PropTypes.func,
  confirmButtonColor: PropTypes.string,
};

export default Modal;


